<template>
  <nav class="satellites-tabs">
    <router-link v-for="tab in tabs" :key="tab.name" :to="{ name: tab.name }" :exact="tab.exact" class="satellites-tabs__item" active-class="_active">
      <SatIcon :name="tab.icon" :size="15" />
      {{ $t(`satellites.tabs.${tab.key}`) }}
    </router-link>
  </nav>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";

export default {
  name: "SatellitesTabs",
  components: { SatIcon },
  data() {
    return {
      // In the order of the setup: servers, their groups, domains, what the domains show (routers of landings and
      // platforms), links to share.
      tabs: [
        { name: "Satellites", key: "satellites", icon: "server", exact: true },
        { name: "SatelliteGroups", key: "groups", icon: "layers" },
        { name: "SatelliteDomains", key: "domains", icon: "globe" },
        { name: "SatelliteRouters", key: "routers", icon: "route" },
        { name: "SatelliteLandings", key: "landings", icon: "file" },
        { name: "SatellitePlatforms", key: "platforms", icon: "grid" },
        { name: "SatelliteLinks", key: "links", icon: "link" },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.satellites-tabs {
  display: flex;
  gap: 0 26px;
  margin-bottom: 22px;
  overflow-x: auto;
  border-bottom: 1px solid var(--sat-border);
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.satellites-tabs__item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 0;
  margin-bottom: -1px;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  color: var(--sat-muted);
  border-bottom: 2px solid transparent;
  text-decoration: none;
  transition: color 0.15s;

  &:hover {
    color: var(--sat-text);
  }

  &._active {
    color: var(--sat-accent);
    border-bottom-color: var(--sat-accent);
  }
}
</style>
